module.exports = __webpack_public_path__ + "static/KRKRR_HOTEL-LOGO_RGB-d87fc88b48439bc1beb4f0cdbe2bb91d.png";